import * as React from 'react';

import LearnItemIcon from 'bundles/learner-progress/components/item/LearnItemIcon';
import type { ContentSummary } from 'bundles/learner-progress/types/ContentSummary';
import type { Item } from 'bundles/learner-progress/types/Item';

import 'css!./__styles__/NavItemIcon';

type Props = {
  computedItem: Item;
  size?: number;
  typeNameOverride?: ContentSummary['typeName'];
};

const NavItemIcon = ({ computedItem, size = 20, typeNameOverride }: Props) => (
  <div className="rc-NavItemIcon">
    <LearnItemIcon computedItem={computedItem} size={size} typeNameOverride={typeNameOverride} />
  </div>
);

export default NavItemIcon;
